import type { QueryClient } from '@tanstack/react-query';
import { notFound, redirect } from '@tanstack/react-router';
import { getViewsQueryOptions } from '@/lib/queries/view/useView';
import { getLastVisitedView } from './lastVisited';

export async function redirectToFirstView({
  org,
  queryClient,
  roadmapId,
}: {
  org: string;
  roadmapId: number;
  queryClient: QueryClient;
}): Promise<void> {
  if (!roadmapId) throw notFound();

  const views = await queryClient.ensureQueryData(getViewsQueryOptions(roadmapId));

  const lastVisitedViewId = getLastVisitedView(roadmapId);
  const targetView =
    (lastVisitedViewId ? views.find((v) => v.viewId === lastVisitedViewId) : undefined) ?? views[0];

  // Redirect to target view if any exist
  if (targetView) {
    throw redirect({
      to: `/org/$org/roadmaps/$roadmapId/view/$viewId`,
      params: { org, roadmapId, viewId: targetView.viewId },
      replace: true,
    });
  }
  throw redirect({
    to: '/org/$org/roadmaps/$roadmapId/items',
    params: { org, roadmapId },
    replace: true,
  });
}
